import {sessionStorageService} from "../../authentication/services/session.storage";
import {request} from "./client";

/** Admin endpoints. An admin is an ordinary site account with is_admin, so these use the site login ("ogm_token"),
 * not the broker session. A 401/403/404 from them means "not signed in as an admin". */
const asAdmin = {auth: () => sessionStorageService.get()};

export const listBrokers = (status) =>
    request(`/admin/brokers${status && status !== "ALL" ? `?status=${encodeURIComponent(status)}` : ""}`, asAdmin);

export const approveBroker = (id) => request(`/admin/brokers/${id}/approve`, {method: "POST", ...asAdmin});

export const rejectBroker = (id) => request(`/admin/brokers/${id}/reject`, {method: "POST", ...asAdmin});

export const suspendBroker = (id) => request(`/admin/brokers/${id}/suspend`, {method: "POST", ...asAdmin});

export const getReviewQueue = () => request("/admin/brokerage/review", asAdmin);

/** decision: "approve" | "request-changes" | "reject"; a note is required unless approving. */
export const decideListing = (id, decision, note) =>
    request(`/admin/brokerage/listings/${id}/${decision}`, {method: "POST", body: {note: note || null}, ...asAdmin});

export const decideProject = (id, decision, note) =>
    request(`/admin/brokerage/projects/${id}/${decision}`, {method: "POST", body: {note: note || null}, ...asAdmin});

export const listSiteStaff = (status) =>
    request(`/admin/site-staff${status && status !== "ALL" ? `?status=${encodeURIComponent(status)}` : ""}`, asAdmin);

export const approveSiteStaff = (id) => request(`/admin/site-staff/${id}/approve`, {method: "POST", ...asAdmin});

export const rejectSiteStaff = (id) => request(`/admin/site-staff/${id}/reject`, {method: "POST", ...asAdmin});

export const listOfficeLeads = () => request("/admin/leads", asAdmin);

export const setOfficeLeadStatus = (id, status) =>
    request(`/admin/leads/${id}/status`, {method: "PUT", body: {status}, ...asAdmin});

export const listAgents = () => request("/admin/agents", asAdmin);

export const setUpAgentAuthenticator = (id) => request(`/admin/agents/${id}/authenticator`, {method: "POST", ...asAdmin});

export const removeAgentAuthenticator = (id) => request(`/admin/agents/${id}/authenticator`, {method: "DELETE", ...asAdmin});

export const inviteAgent = (payload) => request("/admin/agents", {method: "POST", body: payload, ...asAdmin});

export const suspendAgent = (id) => request(`/admin/agents/${id}/suspend`, {method: "POST", ...asAdmin});

export const activateAgent = (id) => request(`/admin/agents/${id}/activate`, {method: "POST", ...asAdmin});

export const signOutAgentPhones = (id) => request(`/admin/agents/${id}/sign-out-devices`, {method: "POST", ...asAdmin});

export const assignAgentSite = (id, siteType, siteId) =>
    request(`/admin/agents/${id}/sites`, {method: "POST", body: {siteType, siteId}, ...asAdmin});

export const unassignAgentSite = (id, assignmentId) =>
    request(`/admin/agents/${id}/sites/${assignmentId}`, {method: "DELETE", ...asAdmin});

export const checkInAgent = (id, siteType, siteId) =>
    request(`/admin/agents/${id}/check-in`, {method: "POST", body: {siteType, siteId}, ...asAdmin});

export const checkOutAgent = (id) => request(`/admin/agents/${id}/check-out`, {method: "POST", ...asAdmin});

export const listSites = (q) => request(`/admin/sites${q ? `?q=${encodeURIComponent(q)}` : ""}`, asAdmin);

export const saveSiteSettings = (siteType, siteId, settings) =>
    request(`/admin/sites/${siteType}/${siteId}/settings`, {method: "PUT", body: settings, ...asAdmin});

export const pauseSite = (siteType, siteId, paused) =>
    request(`/admin/sites/${siteType}/${siteId}/pause`, {method: "PUT", body: {paused}, ...asAdmin});
